export default __webpack_public_path__ + "static/media/pic1.e9a23e51.jpg";